export const areValuesEqual = (
  current: (string | boolean | number)[],
  initial: (string | boolean | number)[],
): boolean => {
  if (current.length !== initial.length) return false
  return current.every((value, index) => {
    if (typeof value === 'string' && typeof initial[index] === 'string') {
      const currentValue = value.trim() === 'N/A' ? '' : value.trim()
      const initialValue =
        (initial[index] as string).trim() === 'N/A'
          ? ''
          : (initial[index] as string).trim()
      return currentValue === initialValue
    }
    return value === initial[index]
  })
}

const normalizeSettingFieldValue = (
  value: string | boolean | number | null | undefined,
): string | boolean | number => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') {
    return value.trim() === 'N/A' ? '' : value.trim()
  }
  return value
}

export const isSettingFieldChanged = (
  current: string | boolean | number | null | undefined,
  saved: string | boolean | number | null | undefined,
): boolean =>
  normalizeSettingFieldValue(current) !== normalizeSettingFieldValue(saved)

export const settingsFieldClassName = (changed: boolean, extra = ''): string =>
  ['scp-settings-field', changed ? 'scp-settings-field-changed' : '', extra]
    .filter(Boolean)
    .join(' ')
